import { FC, useEffect, useState } from "react";

import "./Avatar.scss";

export type AvatarProps = {
  /**
   * The size of the Avatar. Starts from 'xs' till '2xl'.
   * Default is 'md'.
   */
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

  /**
   * image to show in the avatar
   */
  image?: string;

  /**
   * name's initials will be shown inside the avatar
   */
  name?: string;
};

const Avatar: FC<AvatarProps> = function (props) {
  const { size = "md", image, name } = props;
  const [hasImageError, setHasImageError] = useState(false);

  useEffect(() => {
    setHasImageError(false);
  }, [image]);

  const getInitials = () => {
    if (!name) return "00";
    const words = name.trim().split(" ");
    return words
      .map((word) => word.charAt(0).toUpperCase())
      .join("")
      .substring(0, 2);
  };

  const showImage = Boolean(image) && !hasImageError;

  return (
    <div className={`avatar avatar-${size} ${showImage ? "avatar-spacing bg-primary" : "avatar-bg-tertiary"}`}>
      {showImage ? (
        <img
          className="avatar__img"
          src={image}
          alt="avatar-img"
          onError={() => setHasImageError(true)}
        />
      ) : (
        <div className="avatar__initials">{getInitials()}</div>
      )}
    </div>
  );
};

export default Avatar;

Avatar.defaultProps = {
  size: "md",
  image: undefined,
  name: undefined,
};
